import axios from 'axios';

// Lokal: frontend (3000) ve API (3001) ayrı çalışıyorsa REACT_APP_API_URL veya 3001 kullanılır
function getBaseURL(): string {
  if (typeof window !== 'undefined') {
    const isLocalhost = /localhost|127\.0\.0\.1/.test(window.location.hostname);
    if (isLocalhost) {
      const envUrl = process.env.REACT_APP_API_URL;
      if (envUrl) return envUrl;
      return 'http://localhost:3001/api';
    }
  }
  return process.env.REACT_APP_API_URL || 'https://api.dugmehobi.com/api';
}

const API_URL = getBaseURL();
const isDevelopment = process.env.NODE_ENV === 'development';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false,
  timeout: 15000,
  validateStatus: (status) => status < 500,
});

// Request interceptor - only log in development mode
api.interceptors.request.use(
  (config) => {
    if (isDevelopment) {
      console.log(`[API Request] ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    }
    return config;
  },
  (error) => {
    if (isDevelopment) {
      console.error('[API Request Error]', error);
    }
    return Promise.reject(error);
  }
);

// Response interceptor - only log in development mode
api.interceptors.response.use(
  (response) => {
    if (isDevelopment) {
      console.log(`[API Response] ${response.config.url} - ${response.status}`);
    }
    return response;
  },
  (error) => {
    if (isDevelopment) {
      if (error.response) {
        console.error('[API Error Response]', error.response.status, error.response.data);
      } else if (error.request) {
        console.error('[API Error] No response received');
      } else {
        console.error('[API Error]', error.message);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
